import React, { useState } from 'react';
import classNames from 'classnames';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import css from './BulletPointsField.module.css';
import { Field } from 'react-final-form';
import Button from '../Button/Button';
import InfoTipForFields from '../InfoTipForFields/InfoTipForFields';

const BulletPointsField = props => {
  const { label, id, name, tipId, isRequired } = props;
  const bulletPointsFieldComponent = ({ input: { onChange, value }, label, ...rest }) => {
    const [options, setOptions] = useState(value || []);
    const [inputValue, setInputValue] = useState(null);

    return (
      <div className={css.fieldWrapper}>
        <p className={css.fieldLabel}>{label}{tipId && <InfoTipForFields tipId={tipId} />}</p>
        <div className={css.inputWrapper}>
          <span className={classNames({ [css.isRequired]: isRequired })}></span>
          <div className={css.textInputHolder}>
            <input
              className={css.textInput}
              value={inputValue}
              onChange={e => setInputValue(e.target.value)}
              placeholder={'Type here...'}
            />
            <p className={css.textInputTip}>
              Minimum 3 characters
            </p>
          </div>
          <Button
            className={css.addButton}
            type="button"
            onClick={() => {
              if (inputValue) {
                onChange([...options, inputValue]);
                setOptions([...options, inputValue]);
                setInputValue(null);
              }
            }}
            disabled={inputValue?.length < 3 || !inputValue?.length}
          >
            Add
          </Button>
        </div>

        <div className={css.bulletsWrapper}>
          {Array.isArray(options) && options?.map(o => {
            return (
              <div className={css.bullet}>
                <div className={css.bulletButton}>
                  <DeleteIcon
                    className={css.deleteIcon}
                    onClick={() => {
                      const newValues = options.filter(x => x !== o);
                      onChange(newValues);
                      setOptions(newValues);
                    }}
                  />
                </div>
                <div className={css.bulletLabel}>
                  {'• '}
                  {o}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return <Field id={id} name={name} label={label} component={bulletPointsFieldComponent} />;
};

export default BulletPointsField;
